import { colorPalette } from '../../colorPalette';
export const productDiscountContainer = () => ({
    marginTop: '4px',
});
export const productPriceBefore = (overlined = false) => {
    return {
        fontWeight: 400,
        lineHeight: '1.6rem',
        fontSize: '1.4rem',
        color: colorPalette.gray700,
        letterSpacing: '0.3px',
        textDecoration: overlined ? 'line-through' : '',
    };
};
export const productDiscount = () => ({
    fontSize: '1.4rem',
    color: colorPalette.white,
    backgroundColor: colorPalette.lightBlue600,
    padding: '2px 5px',
    width: '32px',
    height: '16px',
    fontFamily: 'RakutenSansUiSemiBold, serif',
    marginLeft: '8px',
    borderRadius: '2px',
});
export const crossedPriceDisplay = (display = 'inline') => {
    return {
        display: 'flex',
        gap: display === 'inline' ? '1px' : '0.4rem',
        flexWrap: display === 'inline' ? 'wrap' : 'nowrap',
        flexDirection: display === 'inline' ? 'row' : 'column',
        justifyContent: display === 'inline' ? 'flex-start' : 'center',
        alignItems: display === 'inline' ? 'baseline' : 'center',
    };
};
export const displayLabel = () => ({
    display: 'flex',
    gap: '0.4rem',
    flexDirection: 'row',
    alignItems: 'center',
});
export const toolTip = () => ({
    width: '16px',
    color: colorPalette.gray700,
    cursor: 'pointer',
});
export const discountStyle = {
    backgroundColor: colorPalette.lightBlue600,
    color: colorPalette.white,
    padding: '4px',
    borderRadius: '0px 4px 4px 0px',
};
export const priceType = (isNew) => {
    return {
        fontWeight: 400,
        lineHeight: '1.6rem',
        fontSize: '1.4rem',
        color: colorPalette.gray700,
        letterSpacing: '0.3px',
        textDecoration: isNew ? 'line-through' : '',
    };
};
export const toolTipPopper = () => ({
    color: colorPalette.gray1000,
    fontSize: '14px',
    fontWeight: 400,
    '& :nth-child(2)': {
        margin: '4px 0',
    },
});
export const toolTipPopperTitle = () => ({
    fontWeight: 600,
});
export const tooltipLink = () => ({
    color: colorPalette.gray1000,
    textDecoration: 'none',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
});
export const arrow = () => ({
    backgroundColor: '#fff',
    border: 'solid #EBEBEB',
    borderWidth: '1px 0 0 1px',
    height: '16px',
    width: '16px',
    zIndex: 99,
    transform: 'rotate(45deg)',
    position: 'absolute',
    top: '-9px',
    left: '50%',
});
